var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWritelogoCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.820524C0 0.367361 0.367361 0 0.820524 0H22.7012C23.1543 0 23.5217 0.367361 23.5217 0.820524V9.02576C23.5217 9.47893 23.1543 9.84629 22.7012 9.84629C22.248 9.84629 21.8806 9.47893 21.8806 9.02576V1.64105H1.64105V16.4105H11.7608C12.214 16.4105 12.5814 16.7778 12.5814 17.231C12.5814 17.6842 12.214 18.0515 11.7608 18.0515H0.820524C0.367361 18.0515 0 17.6842 0 17.231V0.820524Z",
    fill: "#E38226"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.164153 0.328258C0.436051 -0.0342724 0.950356 -0.107745 1.31289 0.164153L11.7609 8.00016L22.2089 0.164153C22.5714 -0.107745 23.0857 -0.0342724 23.3576 0.328258C23.6295 0.690788 23.556 1.20509 23.1935 1.47699L12.2532 9.68223C11.9615 9.90104 11.5603 9.90104 11.2686 9.68223L0.328258 1.47699C-0.0342724 1.20509 -0.107745 0.690788 0.164153 0.328258Z",
    fill: "#E38226"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6462 15.9503C14.6462 18.7476 16.9084 20.9996 19.6956 20.9996C22.4829 20.9996 24.745 18.7375 24.745 15.9503C24.745 13.163 22.493 10.9009 19.6956 10.9009C16.9084 10.9009 14.6462 13.1529 14.6462 15.9503ZM19.876 13.9969C20.2734 13.9969 20.5872 14.3211 20.5872 14.7081C20.5872 15.0951 20.2734 15.4194 19.876 15.4194H17.7422C17.3448 15.4194 17.031 15.0951 17.031 14.7081C17.031 14.3211 17.3448 13.9969 17.7422 13.9969H19.876ZM17.7422 18.2643C17.3448 18.2643 17.031 17.9401 17.031 17.5531C17.031 17.1661 17.3552 16.8418 17.7422 16.8418H22.0201C22.4176 16.8418 22.7314 17.1661 22.7314 17.5531C22.7314 17.9401 22.4071 18.2643 22.0097 18.2643H17.7422Z",
    fill: "#E38226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritelogoCopy);
export default __webpack_public_path__ + "static/media/write logo - Copy.78179a4232000e79e65ae230e75efebc.svg";
export { ForwardRef as ReactComponent };